import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Header from '../../components/ui/Header';
import HeroSection from './components/HeroSection';
import MissionSection from './components/MissionSection';
import HowItWorksSection from './components/HowItWorksSection';
import ValuesSection from './components/ValuesSection';
import TeamSection from './components/TeamSection';
import ImpactSection from './components/ImpactSection';
import TechnologySection from './components/TechnologySection';
import PressSection from './components/PressSection';
import CTASection from './components/CTASection';

const About = () => {
  const navigate = useNavigate();
  const { t } = useTranslation(['about', 'common']);

  const handleNavigation = (path) => {
    navigate(path);
  };

  return (
    <div className="min-h-screen bg-background">
      <Header />

      <main className="pt-16 lg:pt-20">
        <HeroSection onNavigate={handleNavigation} />
        <MissionSection />
        <HowItWorksSection />
        <ValuesSection />
        <TeamSection />
        <ImpactSection />
        <TechnologySection />
        <PressSection />
        <CTASection onNavigate={handleNavigation} />
      </main>

      {/* Footer */}
      <footer className="bg-accent-800 text-white py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-4 gap-8">
            <div>
              <div className="flex items-center space-x-3 mb-4">
                <div className="w-10 h-10 bg-gradient-to-br from-primary-400 to-secondary-400 rounded-xl flex items-center justify-center">
                  <span className="text-white font-bold text-lg">G</span>
                </div>
                <div>
                  <h3 className="font-heading font-bold text-xl">{t('common:footer.sections.giftFinder')}</h3>
                  <p className="font-accent text-sm text-secondary-400">{t('common:footer.tagline')}</p>
                </div>
              </div>
              <p className="text-accent-300 text-sm leading-relaxed">
                {t('about:footer.description')}
              </p>
            </div>

            <div>
              <h4 className="font-heading font-bold text-lg mb-4">{t('common:footer.platform')}</h4>
              <ul className="space-y-2 text-sm">
                <li><button onClick={() => handleNavigation('/gift-finder')} className="text-accent-300 hover:text-white transition-colors">{t('common:footer.sections.giftFinder')}</button></li>
                <li><button onClick={() => handleNavigation('/wishlists')} className="text-accent-300 hover:text-white transition-colors">{t('common:footer.sections.wishlists')}</button></li>
                <li><button onClick={() => handleNavigation('/occasions')} className="text-accent-300 hover:text-white transition-colors">{t('common:footer.sections.occasions')}</button></li>
                <li><button onClick={() => handleNavigation('/community')} className="text-accent-300 hover:text-white transition-colors">{t('common:footer.sections.community')}</button></li>
              </ul>
            </div>

            <div>
              <h4 className="font-heading font-bold text-lg mb-4">{t('common:footer.support')}</h4>
              <ul className="space-y-2 text-sm">
                <li><button onClick={() => handleNavigation('/about')} className="text-accent-300 hover:text-white transition-colors">{t('common:footer.sections.aboutUs')}</button></li>
                <li><a href="#" className="text-accent-300 hover:text-white transition-colors">{t('common:footer.sections.helpCenter')}</a></li>
                <li><a href="#" className="text-accent-300 hover:text-white transition-colors">{t('common:footer.sections.contactUs')}</a></li>
                <li><a href="#" className="text-accent-300 hover:text-white transition-colors">{t('common:footer.sections.privacyPolicy')}</a></li>
              </ul>
            </div>

            <div>
              <h4 className="font-heading font-bold text-lg mb-4">{t('common:footer.connect')}</h4>
              <ul className="space-y-2 text-sm">
                <li><a href="#" className="text-accent-300 hover:text-white transition-colors">{t('common:footer.sections.newsletter')}</a></li>
                <li><a href="#" className="text-accent-300 hover:text-white transition-colors">{t('common:footer.sections.blog')}</a></li>
                <li><a href="#" className="text-accent-300 hover:text-white transition-colors">{t('common:footer.sections.socialMedia')}</a></li>
                <li><a href="#" className="text-accent-300 hover:text-white transition-colors">{t('common:footer.sections.pressKit')}</a></li>
              </ul>
            </div>
          </div>

          <div className="border-t border-accent-700 mt-8 pt-8 text-center">
            <p className="text-accent-300 text-sm">
              {t('about:footer.copyright', { year: new Date().getFullYear() })}
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default About;